import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { getSessionStorage, setSessionStorage, StorageKey } from '@utils/StorageUtils';
import { MainFilterTypesMP } from '@state/actions/Type';
import { FilterKeys } from '@utils/pageConfig/Types';
import { RelativePeriod } from '@components/comparison-period-selector/Types';
import { NO_OPTIONS } from '@utils/StringConstants';
import { MainFiltersMarketPremiumAction } from '@state/actions/main-filter-market-premium/MainFiltersMarketPremiumAction';
import { MainFilterStateMarketPremium } from '@state/reducers/main-filter-market-premium/Types';

const getInitialState = () => {
  const storeMarketPremiumMainFilters = JSON.parse(getSessionStorage(StorageKey.MarketPremiumMainFilters) as string);

  if (storeMarketPremiumMainFilters !== null) {
    return {
      timeFrame: storeMarketPremiumMainFilters.timeFrame,
      period: storeMarketPremiumMainFilters.period,
      comparisonPeriod: storeMarketPremiumMainFilters.comparisonPeriod,
      selectedGrowthType: storeMarketPremiumMainFilters.selectedGrowthType,
      feature: storeMarketPremiumMainFilters.feature,
      customMonthsPeriodState: storeMarketPremiumMainFilters?.customMonthsPeriodState,
      customWeeksPeriodState: storeMarketPremiumMainFilters?.customWeeksPeriodState,
    };
  }

  return Object.freeze({
    timeFrame: Periodicity.Weekly,
    period: {
      value: '',
      label: '',
      lastUpdatedDate: 0,
    },
    comparisonPeriod: RelativePeriod.PreviousYearCurrentPeriod,
    selectedGrowthType: GrowthTypes.percentage,
    feature: {
      label: NO_OPTIONS,
      value: NO_OPTIONS,
      dataType: NO_OPTIONS,
      feature: NO_OPTIONS,
      filterKey: FilterKeys.BRAND, //Brand here not for default value , just put for feature object filter key
    },
    customMonthsPeriodState: {
      period: null,
      comparisonPeriod: null,
    },
    customWeeksPeriodState: {
      period: null,
      comparisonPeriod: null,
    },
  });
};

const MainFiltersMarketPremiumReducer = (
  state: MainFilterStateMarketPremium = getInitialState(), //NOSONAR typescript:S1788
  action?: MainFiltersMarketPremiumAction,
) => {
  if (action) {
    const actionType = action.type;
    switch (actionType) {
      case MainFilterTypesMP.MainFiltersUpdatedMP: {
        const finalPayLoad = {
          ...state,
          ...action.payload,
        };
        setSessionStorage(StorageKey.MarketPremiumMainFilters, JSON.stringify(finalPayLoad));
        return finalPayLoad;
      }
      case MainFilterTypesMP.UpdateMFMPGrowthType:
      case MainFilterTypesMP.UpdateMFMPPeriod:
      case MainFilterTypesMP.UpdateMFMPPeriodicity:
      case MainFilterTypesMP.UpdateMFMPComparisonPeriod:
      case MainFilterTypesMP.UpdateMFMPCustomMonthsPeriodState:
      case MainFilterTypesMP.UpdateMFMPCustomWeeksPeriodState: {
        const field = MFMP_ACTION_KEY_MAP[action.type];
        if (field) {
          const finalPayLoad = {
            ...state,
            [field]: action.payload,
          };
          setSessionStorage(StorageKey.MarketPremiumMainFilters, JSON.stringify(finalPayLoad));
          return finalPayLoad;
        }
      }
    }
  }
  return state;
};

const MFMP_ACTION_KEY_MAP = {
  [MainFilterTypesMP.UpdateMFMPGrowthType]: 'selectedGrowthType',
  [MainFilterTypesMP.UpdateMFMPPeriod]: 'period',
  [MainFilterTypesMP.UpdateMFMPPeriodicity]: 'timeFrame',
  [MainFilterTypesMP.UpdateMFMPComparisonPeriod]: 'comparisonPeriod',
  [MainFilterTypesMP.UpdateMFMPCustomMonthsPeriodState]: 'customMonthsPeriodState',
  [MainFilterTypesMP.UpdateMFMPCustomWeeksPeriodState]: 'customWeeksPeriodState',
};
export default MainFiltersMarketPremiumReducer;
